define('bindingHandlers/carousel',[
    'lib/knockout',
    'lib/lodash4',
    'jquery'
], function (ko, _, $) {
    'use strict';

    var $carouselElement,
        $carouselWrapper,
        carouselInnerWidth,
        totalCarouselItems,
        totalCarouselItemsWidth;


    /**
     * set the carouselElement and carouselWrapper
     */
    var setCarouselElements = function(element) {
        $carouselElement = $(element);
        $carouselWrapper = $(element).find('.carousel-wrapper');
    };

    /**
     * set carouselInnerWidth
     */
    var setCarouselInnerWidth = function() {
        carouselInnerWidth = $carouselWrapper.innerWidth();
    };

    /**
     * set totalCarouselItems
     */
    var setTotalCarouselItems = function(items) {
        totalCarouselItems = items;
    };

    /**
     * Get the number of items in the carousel
     */
    var getCarouselItems = function() {
        return $carouselWrapper.find('.carousel-item');
    };

    /**
     * set totalCarouselItemsWidth
     */
    var setTotalCarouselItemsWidth = function() {

        /*
        Need to wait for items to be loaded in dom to be equal to the
        total number of carousel items
         */
        var timer = setInterval(function() {

            var carouselLengthInDom = getCarouselItems().length;
            var width = 0;
            var totalWidth = 0;

            if (carouselLengthInDom === totalCarouselItems) {
                _.each(getCarouselItems(), function(item) {
                    width = parseInt($(item).outerWidth(), 10);
                    totalWidth = totalWidth + width;
                });
                totalCarouselItemsWidth = totalWidth;
                setHasOverflow();
                clearInterval(timer);
            }

        }, 100);


    };

    /**
     * add class 'has-overflow' if content is overflowing.
     * This shows or hides the carousel pager
     */
    var setHasOverflow = function () {
        if (totalCarouselItemsWidth > carouselInnerWidth) {
            $carouselElement.addClass('has-overflow');
        } else {
            $carouselElement.removeClass('has-overflow');
        }
    };

    /**
     * handle the browser resize event
     * @param  {Event} event - the event object
     */
    var handleResizeEvent = function() {
        setCarouselInnerWidth();
        setHasOverflow();
    };

    var getPageOffset = function (viewportWidth, contentWidth, initalPadding, pageNumber) {
        var itemWidth = contentWidth / totalCarouselItems;
        var remainderWidth = viewportWidth % itemWidth;
        var pageItemsWidth = viewportWidth - remainderWidth;

        var offset = ((pageNumber - 1) * pageItemsWidth) - (remainderWidth / 2) + (initalPadding / 2);
        offset = Math.max(0, offset);
        offset = Math.min(contentWidth, offset);

        //if we're on the last page, figure out how many there are so we can update the page value correctly
        //in case someone tried to set a page number that was too high.
        if (offset == contentWidth) {
            pageNumber = Math.floor(totalCarouselItems / Math.floor(viewportWidth / itemWidth));
        }

        return {
            offset: offset,
            page: pageNumber
        };
    };

    var showPage = function (pageNumber, initialPadding) {
        var viewportWidth = $carouselWrapper.innerWidth();
        var contentWidth = $carouselWrapper[0].scrollWidth;
        var offsetInfo = getPageOffset(viewportWidth, contentWidth, initialPadding, pageNumber);

        $carouselWrapper.animate({scrollLeft: offsetInfo.offset}, 1000);
        return offsetInfo.page;
    };

    /**
     * Using the Carousel Binding Handler
     *
     * The binding value accessible through valueAccessor() requires three properties:
     *
     * displayedPage:  an Observable referring to the initial page of the carousel.
     * totalItems:     the number of items in the carousel
     * initialPadding: initial padding used to compute the page offset for animating scroll
     *
     * @example
     *
     * <div class="carousel" data-bind="
     *     carousel: {
     *         displayedPage: interactionsPage,
     *         totalItems: interactions.peek().length,
     *         initialPadding: 20
     *     }
     * ">
     *
     *     <a class="carousel-pager carousel-pager-left" data-bind="click: prevInteractionsPage" href="#">
     *         <i class="fa fa-lg fa-chevron-left"></i>
     *         <span class="sr-only"></span>
     *     </a>
     *     <a class="carousel-pager carousel-pager-right" data-bind="click: nextInteractionsPage" href="#">
     *         <i class="fa fa-lg fa-chevron-right"></i>
     *         <span class="sr-only"></span>
     *     </a>
     *
     *     <div class="carousel-wrapper">
     *         <ul class="carousel-items" data-bind="foreach: someCollection">
     *              <li class="carousel-item" data-bind="css: cssClasses"></li>
     *         </ul>
     *     </div>
     *
     * </div>
     *
     * TODO: Maybe handle pagination all in the carousel binding handler
     *
     */

    ko.bindingHandlers.carousel = {

        /**
         * Sets variables used to compute if the total width of
         * items in the carousel overflows the carousel wrapper.
         * Also, bind handleResizeEvent to the resize event.
         *
         * @param  {Object}   element        The DOM element involved in this binding
         * @param  {Function} valueAccessor  A JavaScript function that you can call to get the
         *                                   current model property that is involved in this binding.
         */
        init: function (element, valueAccessor) {

            var info = ko.utils.unwrapObservable(valueAccessor());

            setCarouselElements(element); // set container elements
            setTotalCarouselItems(ko.utils.unwrapObservable(info.totalItems)); // set the total items in the carousel
            setCarouselInnerWidth(); // set the width of the inner container (.carousel-wrapper)
            setTotalCarouselItemsWidth(); // set the width of all the carousel items


            $(window).on('resize', handleResizeEvent); // listen to resize event

            // Binding handler cleanup
            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                $(window).off('resize', $carouselWrapper, handleResizeEvent);
            });

        },

        /**
         * Updates variables necessary to recalculate if the total width of
         * items in the carousel overflows the carousel wrapper.
         * Also, setup the pagination controls for the carousel
         *
         * @param  {Object}   element        The DOM element involved in this binding
         * @param  {Function} valueAccessor  A JavaScript function that you can call to get the
         *                                   current model property that is involved in this binding.
         */
        update: function (element, valueAccessor) {

            var info = ko.utils.unwrapObservable(valueAccessor());
            var toShow = Math.max(ko.utils.unwrapObservable(info.displayedPage), 1);
            var initialPadding = ko.utils.unwrapObservable(info.initialPadding) || 0;

            setTotalCarouselItems(ko.utils.unwrapObservable(info.totalItems));
            setTotalCarouselItemsWidth();

            var actualPageNumber = showPage(toShow, initialPadding);

            //Write the actual page number back if we can
            if (ko.isWriteableObservable(info.displayedPage)) {
                info.displayedPage(actualPageNumber);
            }
        }
    };
});

